exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--option__1uOGa{display:-webkit-box;display:-ms-flexbox;display:flex;margin:5px 5px 0 0}.styles--image__-Cf7Z{-webkit-box-sizing:border-box;box-sizing:border-box;background-size:cover;width:120px;height:120px;border-radius:5px}.styles--active__7mdj7{border:5px solid #79a5d2}.styles--checkbox__1pvJE{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}\n", ""]);

// exports
exports.locals = {
	"option": "styles--option__1uOGa",
	"image": "styles--image__-Cf7Z",
	"active": "styles--active__7mdj7",
	"checkbox": "styles--checkbox__1pvJE"
};